import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/layout";
import './App.css';
import Subscribe from "./pages/subscribe";
import EmailVerification from "./pages/email-verification";
import Status from "./pages/status";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Layout />}>
          <Route index element={<Subscribe />} />
          <Route path='verification' element={<EmailVerification />} />
          <Route path='status' element={<Status />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
